import { lazy, Suspense } from "react";
import { PATHS } from "@/lib/router";
import { RouteLoading } from "@/components/common";

const SurveysPage = lazy(() => import("./pages/SurveysPage"));
const SurveyTakePage = lazy(() => import("./pages/SurveyTakePage"));
const SurveyResponseDetailPage = lazy(
  () => import("./pages/SurveyResponseDetailPage"),
);
const CreateStandardSurveyPage = lazy(
  () => import("./pages/CreateStandardSurveyPage"),
);
const EditStandardSurveyPage = lazy(
  () => import("./pages/EditStandardSurveyPage"),
);
const CreateCustomSurveyPage = lazy(
  () => import("./pages/CreateCustomSurveyPage"),
);
const EditCustomSurveyPage = lazy(() => import("./pages/EditCustomSurveyPage"));

export const surveysRoutes = [
  {
    path: PATHS.SURVEYS,
    element: <SurveysPage />,
    handle: { permission: { resource: "surveys", action: "view" } },
  },
  {
    path: PATHS.SURVEY_RESPONSE_DETAIL,
    element: <SurveyResponseDetailPage />,
    handle: { permission: { resource: "surveys", action: "view" } },
  },
  {
    path: PATHS.STANDARD_SURVEY_NEW,
    element: <CreateStandardSurveyPage />,
    handle: { permission: { resource: "surveys", action: "create" } },
  },
  {
    path: PATHS.STANDARD_SURVEY_EDIT,
    element: <EditStandardSurveyPage />,
    handle: { permission: { resource: "surveys", action: "update" } },
  },
  {
    path: PATHS.CUSTOM_SURVEY_NEW,
    element: <CreateCustomSurveyPage />,
    handle: { permission: { resource: "surveys", action: "create" } },
  },
  {
    path: PATHS.CUSTOM_SURVEY_EDIT,
    element: <EditCustomSurveyPage />,
    handle: { permission: { resource: "surveys", action: "update" } },
  },
];

export const surveysPublicRoutes = [
  {
    path: `${PATHS.SURVEY_TAKE}/:surveyType/:surveyId`,
    element: (
      <Suspense fallback={<RouteLoading />}>
        <SurveyTakePage />
      </Suspense>
    ),
  },
];
